<template>
  <v-app>
    <mbgl class="map"></mbgl>
    <nav-drawer />
    <v-img :src="require(`@/assets/legend.png`)" class="legend" width="75"></v-img>
  </v-app>
</template>

<script>
import NavDrawer from "./components/NavDrawer";
import Map from "./components/Map";

export default {
  name: "App",

  components: {
    mbgl: Map,
    NavDrawer
  },

  data: () => ({
    //
  })
};
</script>

<style scoped>
.map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.legend {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 10%;
}
</style>
